(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["featured-products-slide"] && !window.DesignMode) return;
  try {
    
  $(function(){
    $(".nano").enscroll({ verticalScrolling:false,horizontalScrolling:true,pollChanges:false });
    landingSliderOffset();
    $(window).resize(function(){landingSliderOffset()});
  });

  function landingSliderOffset() {
    var logoOffsetLeft = $("footer.site-footer .site-footer__copyright--bottom").offset().left + 15;
    var featuredProductCount = $(".featured-product-item").length;
	if (window.innerWidth >= 768) {
      $(".feature-row-slider").attr("style","margin-left:"+logoOffsetLeft+"px;");
    } else {
      $(".feature-row-slider").attr("style","margin-left:30px;");
    }
    
    /* $(".feature-row-slider").attr("style","width:"+((featuredProductCount+1)*260)+(520+logoOffsetLeft)+"px;"); */
    $(".enscroll-track.horizontal-track").parent().attr("style","position:absolute;left:"+logoOffsetLeft+"px;right:"+logoOffsetLeft+"px;");
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !window.DesignMode) return;
  try {
    
  $(function(){
  	$(".hero-slider-container").owlCarousel({items:1,loop:true,nav:true,navText:["",""],autoplay:true,autoplayTimeout:8000})
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !window.DesignMode) return;
  try {
    
if(document.getElementById('instafeed')){
  var feed = new Instafeed({
      get: 'user',
      userId: '2346277698',
      clientId: 'f368d2add41e4179a14e667e71178c94',
      accessToken: '2346277698.1677ed0.110faf4c5f4d47a4be95f08f39e5fbfc',

      limit: 10,
      resolution: 'Low_resolution',
      template: '<div class="col-5ths"><a href="{{link}}" target="_blank" class="product-square" style="background-image:url({{image}});"><img src="{{image}}"/></a></div>'
  });
  feed.run();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-slider"]) return;
  try {
    
  $(function(){

    $('.owl-carousel-top').owlCarousel({
      loop				: true,
      center			: false,
      margin			: 20,
      nav				: true,
      navText			: ["",""],
      URLhashListener	: true,
      autoplayHoverPause: true,
      startPosition		: 'URLHash',
      responsive 		: {
        0   : { items:1 },
        768 : { items:2 }
      }
    });

    if (window.innerWidth >= 993 ) {
      $(".js-prodZoom-wrap").zoom({
        url: $(this).data("zoom")
      });
    }

    $(".js-zoom-wrap").fancybox({
      type: "image",
      scrolling: "auto"
    });

    
  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !window.DesignMode) return;
  try {
    
  $(function(){
  	$(".shop-the-look-slider").owlCarousel({items:1,loop:true,nav:true,navText:["",""],autoplay:false,autoplayTimeout:8000})
  });

  } catch(e) { console.error(e); }
})();

})();
